export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">关于我们</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">了解蓝莓影院的初心与坚持</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              蓝莓影院成立于2024年，是一个致力于为广大影迷提供<strong className="text-foreground-900">高清免费在线观影</strong>服务的平台。
              我们深知观众对画质和流畅度的追求，因此所有片源均经过严格筛选，确保每一部影片都能以<strong className="text-foreground-900">1080P及以上高清品质</strong>呈现。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台涵盖动作、悬疑、古装、科幻、纪录、动画等多种类型，从最新<strong className="text-foreground-900">热播电视剧全集</strong>到经典<strong className="text-foreground-900">高分电影大全</strong>，
              满足不同观众的多样化观影需求。我们的编辑团队每日追踪各大平台最新动态，确保内容<strong className="text-foreground-900">每日更新</strong>，热播剧集准时追更。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              蓝莓影院的核心承诺是<strong className="text-foreground-900">不缓冲、不收费、不卡顿</strong>。
              采用先进的CDN加速与智能预加载技术，让您在任何网络环境下都能享受流畅的观影体验。未来我们将持续优化服务，丰富内容库，努力成为您最信赖的在线观影伙伴。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}